import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_relay = _resolveComponent("relay")
  const _component_el_form = _resolveComponent("el-form")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_dialog_shell, {
      title: _ctx.$wordList.TabelPersonDeviceTitleMod,
      onClose: _ctx.close,
      onSubmit: _ctx.checkValid
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-position": _ctx.$formLabelPosition,
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "deviceEditFormRef"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.ChangeWordList.PMSetAccessBuildOrDepartment
            }, {
              default: _withCtx(() => [
                (_ctx.projectType==='community')
                  ? (_openBlock(), _createBlock("div", _hoisted_1, _toDisplayString(_ctx.formData.UnitName || "--"), 1))
                  : (_ctx.projectType==='office')
                    ? (_openBlock(), _createBlock("div", _hoisted_2, _toDisplayString(_ctx.formData.DepartmentName || "--"), 1))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"]),
            (_ctx.projectType==='community')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: _ctx.$wordList.ProperAllTextApt
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", null, _toDisplayString(_ctx.formData.RoomName || "--"), 1)
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.TabelDeviceInHtmlLocation,
              prop: "Location"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.Location,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.Location = $event)),
                  "auto-complete": "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            (_ctx.formData.Type === '0' && _ctx.formData.Grade === '2')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: _ctx.$wordList.ProperAllTextContactsSetting
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      modelValue: _ctx.formData.StairShow,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.StairShow = $event)),
                      label: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.ChangeWordList.DeviceContactFirstSetting), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _hoisted_3,
                    _createVNode(_component_el_radio, {
                      modelValue: _ctx.formData.StairShow,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.StairShow = $event)),
                      label: "3"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.ChangeWordList.DeviceContactSecondSetting), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _hoisted_4,
                    _createVNode(_component_el_radio, {
                      modelValue: _ctx.formData.StairShow,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.StairShow = $event)),
                      label: "2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.ChangeWordList.DeviceContactThirdSetting), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_relay, {
              relay: _ctx.formData.Relay,
              "security-relay": (_ctx.isNew && _ctx.ProjectType === 'community')||(_ctx.ProjectType==='office') ? _ctx.formData.SecurityRelay : false,
              commit: _ctx.commit,
              onGetRelay: _ctx.submit,
              type: _ctx.formData.Type === '2' ? 'local': 'normal'
            }, null, 8, ["relay", "security-relay", "commit", "onGetRelay", "type"]), [
              [_vShow, ['0', '1', '2', '50'].includes(_ctx.formData.Type)]
            ])
          ]),
          _: 1
        }, 8, ["label-position", "model", "rules"])
      ]),
      _: 1
    }, 8, ["title", "onClose", "onSubmit"])
  ]))
}